module.exports = __webpack_public_path__ + "img/opp-real-estate.b3ca0b1a.jpg";